import api from './api';

// Alt ürünleri listele
export const getSubProducts = async () => {
  try {
    console.log('Fetching all sub-products...');
    const response = await api.get('/sub-products/');
    console.log('Sub-products received:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching sub-products:', error);
    throw error;
  }
};

// Belirli bir ürünün alt ürünlerini getir
export const getProductSubProducts = async (productId) => {
  try {
    console.log('Fetching sub-products for product:', productId);
    const response = await api.get(`/sub-products/?productId=${productId}`);
    console.log('Product sub-products received:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching product sub-products:', error);
    throw error;
  }
};

// Alt ürün detayını getir (ID veya slug ile)
export const getSubProduct = async (identifier) => {
  try {
    console.log('Fetching sub-product:', identifier);
    const response = await api.get(`/sub-products/${identifier}`);
    console.log('Sub-product received:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching sub-product:', error);
    throw error;
  }
};

// Yeni alt ürün oluştur
export const createSubProduct = async (productId, data) => {
  try {
    console.log('=== CREATING SUB-PRODUCT ===');
    console.log('Product ID:', productId);
    console.log('Sub-product data:', JSON.stringify(data, null, 2));
    
    // API endpoint: POST /sub-products/{product_id}
    // productId is in the URL path and also in the body
    const requestData = {
      productId: productId,
      ...data
    };
    
    console.log('Request data with productId:', JSON.stringify(requestData, null, 2));
    
    const response = await api.post(`/sub-products/${productId}`, requestData, {
      timeout: 60000
    });
    
    console.log('=== SUB-PRODUCT CREATED ===');
    console.log('Response:', response.data);
    console.log('Sub-product ID:', response.data._id || response.data.id);
    return response.data;
  } catch (error) {
    console.error('=== ERROR CREATING SUB-PRODUCT ===');
    console.error('Error:', error.message);
    console.error('Error code:', error.code);
    
    if (error.response) {
      console.error('Response status:', error.response.status);
      console.error('Response data:', error.response.data);
      console.error('Response headers:', error.response.headers);
      
      // 500 Internal Server Error
      if (error.response.status === 500) {
        const errorMsg = error.response.data?.detail || error.response.data?.message || 'Backend sunucu hatası';
        console.error('Backend error details:', errorMsg);
        throw new Error(`Backend hatası: ${errorMsg}`);
      }
      
      // 405 Method Not Allowed hatası
      if (error.response.status === 405) {
        throw new Error('Backend API bu endpoint için POST metodunu desteklemiyor. Backend geliştiricisine başvurun.');
      }
      
      if (error.response.status === 422 && error.response.data?.detail) {
        console.error('=== VALIDATION ERRORS ===');
        error.response.data.detail.forEach((err, index) => {
          console.error(`Error ${index + 1}:`, err);
        });
        
        // Detaylı hata mesajı oluştur
        const validationErrors = error.response.data.detail
          .map(err => `${err.loc?.join('.')}: ${err.msg}`)
          .join(', ');
        throw new Error(`Veri doğrulama hatası: ${validationErrors}`);
      }
      
      // 404 Not Found hatası
      if (error.response.status === 404) {
        throw new Error('API endpoint bulunamadı. Backend yapılandırmasını kontrol edin.');
      }
    }
    
    if (error.code === 'ECONNABORTED') {
      throw new Error('İstek zaman aşımına uğradı. Lütfen tekrar deneyin.');
    } else if (error.code === 'ERR_NETWORK') {
      throw new Error('Ağ hatası. İnternet bağlantınızı kontrol edin.');
    } else if (error.code === 'ERR_TUNNEL') {
      throw new Error('Bağlantı hatası. Lütfen daha sonra tekrar deneyin.');
    }
    
    throw error;
  }
};

// Alt ürünü güncelle
export const updateSubProduct = async (subProductId, data) => {
  try {
    console.log('Updating sub-product:', subProductId);
    console.log('Update data:', data);
    
    // Order varsa integer'a çevir
    if (data.order !== undefined && data.order !== null) {
      data.order = parseInt(data.order, 10);
    }
    
    const response = await api.put(`/sub-products/${subProductId}`, data, {
      timeout: 60000
    });
    
    console.log('Sub-product updated:', response.data);
    return response.data;
  } catch (error) {
    console.error('=== ERROR UPDATING SUB-PRODUCT ===');
    console.error('Sub-product ID:', subProductId);
    console.error('Error:', error.message);
    
    if (error.response) {
      console.error('Response status:', error.response.status);
      console.error('Response data:', error.response.data);
      
      if (error.response.status === 422 && error.response.data?.detail) {
        console.error('=== VALIDATION ERRORS ===');
        error.response.data.detail.forEach((err, index) => {
          console.error(`Error ${index + 1}:`, err);
        });
      }
    }
    
    if (error.code === 'ECONNABORTED') {
      throw new Error('İstek zaman aşımına uğradı. Lütfen tekrar deneyin.');
    } else if (error.code === 'ERR_NETWORK') {
      throw new Error('Ağ hatası. İnternet bağlantınızı kontrol edin.');
    } else if (error.code === 'ERR_TUNNEL') {
      throw new Error('Bağlantı hatası. Lütfen daha sonra tekrar deneyin.');
    }
    
    throw error;
  }
};

// Sadece order alanını güncelle
export const updateSubProductOrder = async (id, order) => {
  try {
    console.log("→ Sending sub-product order update:", { id, order });
    
    // Order değerini integer olarak gönder
    const res = await api.put(`/sub-products/${id}`, {
      order: parseInt(order, 10)
    });
    
    console.log("← Received response:", res.data);
    return res.data;
  } catch (error) {
    console.error("✗ Sub-product order update failed:", error.response?.data || error.message);
    throw error;
  }
};

// Alt ürünü sil
export const deleteSubProduct = async (subProductId) => {
  try {
    console.log('Deleting sub-product:', subProductId);
    const response = await api.delete(`/sub-products/${subProductId}`);
    console.log('Sub-product deleted:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error deleting sub-product:', error);
    throw error;
  }
};

// Alt ürün görsellerini yükle (çoklu görsel desteği)
export const uploadSubProductImages = async (subProductId, imageFiles) => {
  try {
    console.log('=== UPLOADING SUB-PRODUCT IMAGES ===');
    console.log('Sub-product ID:', subProductId);
    console.log('Number of images:', imageFiles.length);
    
    const formData = new FormData();
    
    // Çoklu görsel ekleme - her görsel için 'images' field'ı kullan
    imageFiles.forEach((imageFile, index) => {
      console.log(`Image ${index + 1}:`, imageFile.name, imageFile.size, 'bytes', imageFile.type);
      formData.append('images', imageFile);
    });
    
    console.log('Making POST request to:', `/sub-products/${subProductId}/images`);
    const response = await api.post(`/sub-products/${subProductId}/images`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 60000
    });
    
    console.log('=== IMAGES UPLOAD SUCCESS ===');
    console.log('Response:', response.data);
    return response.data;
  } catch (error) {
    console.error('=== ERROR UPLOADING SUB-PRODUCT IMAGES ===');
    console.error('Sub-product ID:', subProductId);
    console.error('Error:', error.message);
    console.error('Error code:', error.code);
    
    if (error.response) {
      console.error('Response status:', error.response.status);
      console.error('Response data:', error.response.data);
      console.error('Response headers:', error.response.headers);
    }
    
    if (error.code === 'ECONNABORTED') {
      throw new Error('Görsel yükleme zaman aşımına uğradı. Lütfen tekrar deneyin.');
    } else if (error.code === 'ERR_NETWORK') {
      throw new Error('Ağ hatası. İnternet bağlantınızı kontrol edin.');
    }
    throw error;
  }
};

// Geriye uyumluluk için tek görsel yükleme fonksiyonu
export const uploadSubProductImage = async (subProductId, imageFile) => {
  return uploadSubProductImages(subProductId, [imageFile]);
};

// Bulk image delete - DELETE /images/ API
export const bulkDeleteImages = async (imageUrls) => {
  try {
    console.log("=== BULK DELETE IMAGES (SUB-PRODUCTS) ===");
    console.log("URLs to delete:", imageUrls);
    console.log("Request URL:", `${api.defaults.baseURL}/images/`);
    
    const requestData = {
      urls: imageUrls
    };
    console.log("Request data:", requestData);
    
    const res = await api.delete("/images/", {
      data: requestData,
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    console.log("Bulk delete response:", res.data);
    console.log("Response status:", res.status);
    return res.data;
  } catch (error) {
    console.error("=== BULK DELETE ERROR ===");
    console.error("Error message:", error.message);
    console.error("Error code:", error.code);
    
    if (error.response) {
      console.error("Response status:", error.response.status);
      console.error("Response data:", error.response.data);
      console.error("Response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Request made but no response received:", error.request);
    }
    
    throw error;
  }
};

// Türkçe karakterleri İngilizce'ye çevir
const turkishToEnglish = (text) => {
  return text
    .replace(/ğ/g, 'g')
    .replace(/Ğ/g, 'G')
    .replace(/ü/g, 'u')
    .replace(/Ü/g, 'U')
    .replace(/ş/g, 's')
    .replace(/Ş/g, 'S')
    .replace(/ı/g, 'i')
    .replace(/İ/g, 'I')
    .replace(/ö/g, 'o')
    .replace(/Ö/g, 'O')
    .replace(/ç/g, 'c')
    .replace(/Ç/g, 'C');
};

// Slug oluştur
export const createSlug = (text) => {
  if (!text) return '';
  
  const turkishConverted = turkishToEnglish(text);
  
  return turkishConverted
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');
};


